import { SwiperProps } from 'swiper/react';

import { SCREENS } from '@boss/constants/corporate-jobs';

export const CAROUSEL_SETTINGS = {
  navigation: true,
  slidesPerView: 1.2,
  breakpoints: {
    [SCREENS.md]: {
      slidesPerView: 2.4,
    },
    [SCREENS.lg]: {
      slidesPerView: 4,
    },
  },
} as SwiperProps;
